module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-tall-c05f2f28a23c0c81b435973f10e4bcac.png";